module.exports = "<div *ngIf=\"display\" style=\"padding-top: 25px\">\n\t<canvas [height]=\"chartHeight\" #chartCtx>{{ chart }}</canvas>\n</div>"